import React from 'react';
import SignUp from '../components/SignUp';
import Menu from '../components/Navbar';
import Footer from '../components/Footer';


const P_Registration = () => {


    return (
        <div className='page pt-7 pb-3 h-100'>
            <Menu />
            <SignUp />
            <Footer />
        </ div>
    );
};

export default P_Registration;